export const SUBFAMILY = {
  Bovine: 100000000,
  Porcine: 100000001,
  Caprine: 100000002,
  Equine: 100000003,
  Ovine: 100000004,
  Canine: 100000005,
  Feline: 100000006,
  Cervidae: 100000007,
} as const;

export type SubfamilyNumeric = (typeof SUBFAMILY)[keyof typeof SUBFAMILY];

const SUBFAMILY_NUMERIC_LABELS: Record<number, string> = Object.fromEntries(
  Object.entries(SUBFAMILY).map(([label, value]) => [value, label]),
);

export const SUBFAMILY_LABELS: Record<string, string> = {
  BOVINE: 'Bovine',
  PORCINE: 'Porcine',
  CAPRINE: 'Caprine',
  EQUINE: 'Equine',
  OVINE: 'Ovine',
  CANINE: 'Canine',
  FELINE: 'Feline',
  CERVIDAE: 'Cervidae',
  ...Object.fromEntries(
    Object.entries(SUBFAMILY_NUMERIC_LABELS).map(([num, label]) => [
      num,
      label,
    ]),
  ),
};

export const SUBFAMILY_FILTER_VALUES = Object.keys(SUBFAMILY_LABELS).filter(
  (k) => Number.isNaN(Number(k)),
);

const SUBFAMILY_NUMERIC_TO_KEY: Record<number, string> = Object.fromEntries(
  Object.entries(SUBFAMILY).map(([label, value]) => [
    value,
    label.toUpperCase(),
  ]),
);

export function normalizeSubFamily(
  value: string | number | null | undefined,
): string | undefined {
  if (value == null) return undefined;
  if (typeof value === 'number') return SUBFAMILY_NUMERIC_TO_KEY[value];
  return String(value).toUpperCase();
}
